export default "__VITE_PUBLIC_ASSET__dee95eb5__"